'use client';

import { createContext, useContext } from 'react';

export type AppContextType = {};

export const AppContext = createContext<AppContextType>({});

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return <AppContext.Provider value={{}}>{children}</AppContext.Provider>;
};

export const useAppContext = () => {
  return useContext(AppContext);
};
